'use es6';

import genNewRichText from 'forms-utils-lib/utils/RichText/genNewRichText';
import getUpdatedAlignment from 'forms-utils-lib/utils/RichText/getUpdatedAlignment';
import getUpdatedSrc from 'forms-utils-lib/utils/RichText/getUpdatedSrc';
import { getSelectedFormItemReference } from 'FormsUI/selectors/FormSelection';
import { getCurrentRichTextImageAsDomElement, getCurrentRichTextImage, getAltText, getDataImgWidth, getWidth, getHeight, getAspectRatio } from '../selectors/selectedRichTextImage';
import { updateRichText } from './FormDefinition';
import { defaultImage, ALIGNMENT_OPTIONS } from 'FormsCommonComponents/constants/RichTextImage';
import { getAltTextFromImage } from 'FormsUI/utils/RichTextImageUtils';
const updateAttr = (key, value) => (dispatch, getState) => {
  const state = getState();
  const currentRichTextImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  const currentRichTextImage = getCurrentRichTextImage(state);
  const privateId = getSelectedFormItemReference(state);
  const newRichText = genNewRichText(currentRichTextImageAsDomElement, currentRichTextImage, key, value);
  dispatch(updateRichText(privateId, newRichText));
};
export const updateSrc = src => (dispatch, getState) => {
  const state = getState();
  const currentRichTextImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  const currentRichTextImage = getCurrentRichTextImage(state);
  const privateId = getSelectedFormItemReference(state);
  const newRichText = getUpdatedSrc(currentRichTextImageAsDomElement, currentRichTextImage, defaultImage, src);
  dispatch(updateRichText(privateId, newRichText));
};
export const updateAlt = altText => dispatch => {
  dispatch(updateAttr('alt', altText));
};
export const updateSrcAndAltText = (src, fileName) => (dispatch, getState) => {
  const state = getState();
  const currentAltText = getAltText(state);
  const newAltText = getAltTextFromImage({
    src,
    fileName,
    currentAltText
  });
  dispatch(updateSrc(src));
  dispatch(updateAlt(newAltText));
};
export const updateAlignment = alignment => (dispatch, getState) => {
  const state = getState();
  const currentRichTextImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  const currentRichTextImage = getCurrentRichTextImage(state);
  const privateId = getSelectedFormItemReference(state);
  const newRichText = getUpdatedAlignment(ALIGNMENT_OPTIONS, alignment, currentRichTextImageAsDomElement, currentRichTextImage);
  dispatch(updateRichText(privateId, newRichText));
};
export const updateWidth = width => dispatch => {
  dispatch(updateAttr('width', width));
  dispatch(updateAttr('data-img-width', width));
};
export const updateHeight = height => dispatch => {
  dispatch(updateAttr('data-img-height', height));
};
export const updateAspectRatio = () => (dispatch, getState) => {
  const state = getState();
  const currentRichTextImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  const aspectRatio = getAspectRatio(state);
  const width = getWidth(state);
  const height = getHeight(state);
  if (currentRichTextImageAsDomElement && aspectRatio == null) {
    dispatch(updateAttr('data-img-aspect-ratio', width / height));
  }
};
export const updateImageFile = (url, file) => dispatch => {
  const fileName = file ? file.name : '';
  const width = file ? file.width : '';
  const height = file ? file.height : '';
  dispatch(updateSrcAndAltText(url, fileName));
  dispatch(updateWidth(width));
  dispatch(updateAttr('data-img-height', height));
  dispatch(updateAttr('data-img-aspect-ratio', width / height));
};
export const toggleImageMaxWidth = isMaxWidth => (dispatch, getState) => {
  const state = getState();
  const width = getDataImgWidth(state);
  const updatedWidth = isMaxWidth ? '100%' : width;
  dispatch(updateAttr('width', updatedWidth));
};